<template>
  <v-container fluid tag="section">
    <material-wizard
      v-model="tab"
      title="Novo Expurgo"
      subtitle="Selecione o mês e entidades que serão apagadas"
      :available-steps="tabsLiberadas"
      :tabs="tabs"
      class="mx-auto"
      :loading="loading"
      @click:next="next()"
      @click:prev="back()"
    >
      <expurgo-bdgd-wizard-tabs ref="expurgoBdgdParametros" :items="expurgos" @step-observer="updateTabStatus($event)" />
    </material-wizard>
  </v-container>
</template>

<script>
  import ExpurgosService from '@/services/ExpurgosService';
  import wizardMixins from '@/mixins/wizardMixins';
  import routes from '@/store/modules/routes';

  export default {
    components: {
      ExpurgoBdgdWizardTabs: () => import('@/components/dados/expurgo-bdgd/ExpurgoBdgdWizardTabs'),
      MaterialWizard: () => import('@/components/base/MaterialWizard')
    },
    mixins: [wizardMixins],

    data: () => ({
      tabs: ['Mês dos Dados', 'Entidades', 'Confirmação'],
      loading: false,
      expurgos: {}
    }),

    methods: {
      save() {
        const data = this.$refs.expurgoBdgdParametros.exportData();
        this.loading = true;

        ExpurgosService.save(data)
          .then(() => {
            this.$toast.success('Expurgo de BDGD salvo com sucesso.', '', {
              position: 'topRight'
            });
            this.$router.replace({
              name: routes.state.appRoutes['EXPURGOS_DE_BDGD_HISTORICO']
            });
          })
          .catch(() => {
            this.$toast.error('Erro ao salvar Expurgo de BDGD.', '', {
              position: 'topRight'
            });
          })
          .finally(() => (this.loading = false));
      }
    }
  };
</script>
